import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as common from '../../../../../common'
import type { Expression } from '../../expression'
import type * as expressionNode from '../../node'
import type { FnHelper } from '../helper'
import { Key } from '../key'
import * as fnNode from '../node'

import {
  CommonArgs,
  removeIsolatedValueNodes,
  standardNodeCreator,
} from './utils'

/**
 * TODO ({ key: string; value: any }[] -> object)
 *
 * @param todo TODO
 * @example
 * TODO
 * // ->
 * TODO
 */
export interface GreaterThanOrEqualTo<out T = any> {
  /** {@link GreaterThanOrEqualTo} */
  readonly [Key.GreaterThanOrEqualTo]: T extends boolean
    ? readonly Expression<any>[]
    : never
}
export namespace GreaterThanOrEqualTo {
  export const isGreaterThanOrEqualTo: TypeChecker<GreaterThanOrEqualTo> =
    TypeChecker.Factory.lazy(() =>
      TypeChecker.Factory.object<GreaterThanOrEqualTo>({
        [Key.GreaterThanOrEqualTo]: CommonArgs.isListOfExpressions,
      }),
    ).usingAlias('Fn.GreaterThanOrEqualTo')
  export const assertIsGreaterThanOrEqualTo: TypeAsserter<GreaterThanOrEqualTo> =
    TypeAsserter.Factory.from(isGreaterThanOrEqualTo)

  /**
   * @see {@link Node}
   */
  export class Node<T extends boolean = boolean> extends fnNode.Node<
    T,
    Key.GreaterThanOrEqualTo,
    readonly expressionNode.Node[]
  > {
    public readonly type = common.value.types.Intrinsic.Boolean

    constructor(arg: Node<T>['arg']) {
      super(Key.GreaterThanOrEqualTo, arg)
    }
  }
  export namespace Node {
    export const isNode: TypeChecker<Node> = TypeChecker.Factory.instance(Node)
    export const assertIsNode: TypeAsserter<Node> =
      TypeAsserter.Factory.from(isNode)
  }

  const expressionsInArgs: FnHelper<GreaterThanOrEqualTo>['expressionsInArgs'] =
    fn => fn[Key.GreaterThanOrEqualTo]
  export const HELPER: FnHelper<GreaterThanOrEqualTo> = {
    createNode: standardNodeCreator.comparison({
      compare: (a, b) => a >= b,
      getArgExpressions: expressionsInArgs,
      nodeClass: Node,
    }),
    expressionsInArgs,
    typeChecker: isGreaterThanOrEqualTo,
  }
}
